module.exports = __webpack_public_path__ + "img/img3.b3e88df0.png";